//@flow
// /* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */
/* eslint-disable camelcase */

import Lerc from 'lerc';

export class LercDecode {
    static type: string;
    static verify(img: any) {
        
        const data = img;
        const inputOffset = 0;
        const fileIdView = new Uint8Array(data, inputOffset, 10);
        const fileIdentifierString = String.fromCharCode.apply(null, fileIdView);
        const isCntZImage = fileIdentifierString.trim() === "CntZImage";
        const isLerc2 = fileIdentifierString.substring(0, 5) === "Lerc2";
        return isCntZImage || isLerc2;
    }
    static decode(img: any, callback: Function) {
        const lerc = Lerc.decode(img);
        const lercdata = lerc.pixels[0];
        callback({
            glenum: 'LUMINANCE',
            data: lercdata,
            width: lerc.width,
            height: lerc.height,
            ArrayType: "Float32Array",
            dataType: 'FLOAT',
        });
    }
}

LercDecode.type = 'buffer';
// module.exports.LercDecode = LercDecode;
